module.exports = __webpack_public_path__ + "images/emoji/negative_squared_cross_mark.5cbebae1a7a42195f944.png";